import { useSyncExternalStore } from "react";

/** Below 768 px (Tailwind's `md`): a phone (VisionPlatform specs/web-on-phones WOP-01). */
export const NARROW = "(width < 48rem)";

function subscribe(onChange: () => void) {
  if (typeof window === "undefined" || !window.matchMedia) return () => undefined;
  const q = window.matchMedia(NARROW);
  q.addEventListener("change", onChange);
  return () => q.removeEventListener("change", onChange);
}

/**
 * Whether the screen is narrower than 768 px, following the window as it changes. For a layout CSS alone cannot
 * give, such as a table drawn as cards or filters moved into a sheet, so the page holds one copy of each control.
 */
export function useNarrow(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => typeof window !== "undefined" && !!window.matchMedia?.(NARROW).matches,
    () => false,
  );
}
